import { render, staticRenderFns } from "./SignatureTab.vue?vue&type=template&id=816b5d78"
import script from "./SignatureTab.vue?vue&type=script&lang=js"
export * from "./SignatureTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports